export default "__VITE_ASSET__HNUYJqex__"